import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h5" }, "Users", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invite_user_btn = _resolveComponent("invite-user-btn")!
  const _component_users_table = _resolveComponent("users-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-px-md" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_invite_user_btn, {
        "account-id": _ctx.accountId,
        color: "primary",
        rounded: "",
        onInvited: _ctx.prepend
      }, null, 8, ["account-id", "onInvited"]),
      _createVNode(_component_users_table, {
        "account-id": _ctx.accountId,
        class: "q-my-md",
        ref: "users"
      }, null, 8, ["account-id"])
    ]),
    _: 1
  }))
}